<form [formGroup]="addressForm" class="address-form relative">
  <rkt-icon name="star" class="text-xl absolute -left-7 top-1 text-[#ffb257]"></rkt-icon>
  <rkt-form [form]="addressForm" [fields]="addressFields" [model]="formModel" (modelChange)="onFormUpdate()"></rkt-form>
</form>
